/**
 * 寅午戌合火局，其驿马在申；申子辰合水局，其驿马在寅；亥卯未合木局，其驿马在巳；巳酉丑合金局，其驿马在亥
 */
export const YiMa = {
    "寅": "申",
    "午": "申",
    "戌": "申",
    "申": "寅",
    "子": "寅",
    "辰": "寅",
    "巳": "亥",
    "酉": "亥",
    "丑": "亥",
    "亥": "巳",
    "卯": "巳",
    "未": "巳",
}
/**
 * 丁马又名六丁，每旬之中六丁之辰也；
 * 甲子间中丁卯，甲戌旬中丁丑；甲申旬中丁亥，甲午旬中丁酉；甲辰旬中丁未，甲寅旬中丁巳。
 */
export const DingMa = {
    "甲子": "卯",
    "甲戌": "丑",
    "甲申": "亥",
    "甲午": "酉",
    "甲辰": "未",
    "甲寅": "巳"
}
export const TianMa = {
    "未": "辰",
    "丑": "辰",
    "午": "寅",
    "子": "寅",
    "巳": "子",
    "亥": "子",
    "辰": "戌",
    "戌": "戌",
    "卯": "申",
    "酉": "申",
    "申": "午",
    "寅": "午"
}